import { FiatWallet as OldFiatWalletModel } from "@models";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";

export interface FiatWallet {
	readonly balance: number;
	readonly fiatId: number;
	readonly fiatSymbol: string;
	readonly guid: string;
	readonly isNewWallet: boolean; // TODO temp (until dummy wallets will be removed)
	readonly name: string;
	readonly pendingTransactionsCount: number;
}

export class FiatWalletAdapter extends BaseAdapter<OldFiatWalletModel, FiatWallet> {
	public adapt(item: OldFiatWalletModel): FiatWallet {
		if (!item) {
			return null;
		}

		return {
			balance: item.getBalance(),
			fiatId: Number(item.getFiatId()),
			fiatSymbol: null, // TODO missing in the old model, should it be in the new?
			guid: item.getId(),
			isNewWallet: item.isNew(),
			name: item.getName(),
			pendingTransactionsCount: item.getPendingTransactionCount()
		};
	}
}
